var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5917 16.25C14.9 17.2833 14.1667 18.2916 13.05 18.3083C11.9333 18.3333 11.575 17.65 10.3083 17.65C9.03333 17.65 8.64166 18.2916 7.58333 18.3333C6.49166 18.375 5.66666 17.2333 4.96666 16.225C3.54166 14.1666 2.45 10.375 3.91666 7.82496C4.64166 6.55829 5.94166 5.75829 7.35 5.73329C8.41666 5.71663 9.43333 6.45829 10.0917 6.45829C10.7417 6.45829 11.975 5.56663 13.2667 5.69996C13.8083 5.72496 15.325 5.91663 16.3 7.34996C16.225 7.39996 14.4917 8.41663 14.5083 10.525C14.5333 13.0416 16.7167 13.8833 16.7417 13.8916C16.7167 13.95 16.3917 15.0916 15.5917 16.25ZM10.8333 2.91663C11.4417 2.22496 12.45 1.69996 13.2833 1.66663C13.3917 2.64163 13 3.62496 12.4167 4.32496C11.8417 5.03329 10.8917 5.58329 9.95833 5.50829C9.83333 4.54996 10.3 3.54996 10.8333 2.91663Z",
    fill: "#F8FAFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/Apple.c60a515cf7b8c6cd41528927ac10e128.svg";
export { ForwardRef as ReactComponent };